import { Link } from '@twistopayments/design-system/components/atoms/link'

import type { BlocksFeatureCardComponent } from '@twisto/api-cms'

import { Icon } from 'homepage/components/atoms'

import * as styles from './blocks.styles'

export function FeatureCard({ card }: { card: BlocksFeatureCardComponent }) {
  return (
    <div css={styles.card}>
      <div css={styles.icon}>
        {/* @ts-expect-error until icon names can be regenerated */}
        <Icon color="primary" name={card.icon} size="32" />
      </div>

      <div css={styles.cardTitle}>{card.title}</div>
      <div css={styles.cardDesc}>{card.subtitle}</div>

      <Link href={card.url}>
        {card.urlText}
        {/* @ts-expect-error until icon names/colours can be generated */}
        <Icon color="white" name="ArrowRightIcon" size="16" />
      </Link>
    </div>
  )
}
